import { inject } from '@angular/core';
import { Auth, authState } from '@angular/fire/auth';
import { CanMatchFn, Router } from '@angular/router';
import { from } from 'rxjs';
import { map, mergeMap, take } from 'rxjs/operators';
import { isAllowedSignInEmail } from './allowed-sign-in-email';
import { AuthService } from './auth.service';

/** If already signed in, skip the login page. */
export const loginPageGuard: CanMatchFn = () => {
  const router = inject(Router);
  const auth = inject(Auth);
  const authSvc = inject(AuthService);

  return from(authSvc.redirectReadyPromise()).pipe(
    mergeMap(() => authState(auth).pipe(take(1))),
    map((user) => {
      if (!user) {
        return true;
      }
      if (!isAllowedSignInEmail(user.email)) {
        return router.parseUrl('/unauthorized');
      }
      return router.parseUrl('/home');
    }),
  );
};
